import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import DesktopResponsive from './responsive/WebBuilder/DesktopResponsive';
import MobileResponsive from './responsive/WebBuilder/MobileResponsive';

class WebBuilder extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>EditPage Website Builder | Generate, ReMix, and Edit Live</title>
          <meta
            content="Generate your site from a prompt, ReMix design directions in one click, and edit content directly on the page with built-in style, image, and logo controls."
            name="description"
          />
          <meta
            property="og:title"
            content="EditPage Website Builder | Generate, ReMix, and Edit Live"
          />
          <meta
            property="og:description"
            content="Generate your site from a prompt, ReMix design directions in one click, and edit content directly on the page with built-in style, image, and logo controls."
          />
          <meta
            name="twitter:title"
            content="EditPage Website Builder | Generate, ReMix, and Edit Live"
          />
          <meta
            name="twitter:description"
            content="Generate your site from a prompt, ReMix design directions in one click, and edit content directly on the page with built-in style, image, and logo controls."
          />
          <meta content="EditPage" name="generator" />
          <link rel="canonical" href="https://www.editpage.com/webbuilder" />
        </Helmet>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default WebBuilder;
